import { AppConfig } from '@/types/config';
import axios from '../lib/axios';

export const configService = {
  getConfigs: async (): Promise<AppConfig> => {
    const { data } = await axios.get('/configs/full');
    return data;
  },

  createConfig: async (name: string, data: any): Promise<void> => {
    await axios.post('/configs', { name, data });
  },

  updateConfig: async (configs: AppConfig): Promise<void> => {
    await axios.put(`/configs/batch`, { configs });
  },
}; 